/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Combo_Recipe_TitleInputs */

const vi_combo_recipe_title = /** @type {(inputs: Combo_Recipe_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công thức combo`)
};

/**

* @param {Combo_Recipe_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const combo_recipe_title = /** @type {((inputs?: Combo_Recipe_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Combo_Recipe_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_combo_recipe_title(inputs)
});